import React from 'react';
import './PublicHeader.css';
import PropTypes from 'prop-types';
import envConfig from '../../../envConfig';

const PublicHeader = ({ showLoginBtn }) => (
  <div className="main-layout-header">
    <header id="main-header">
      <div id="main-header-logo">
        <a title="User Welcome Page" href="/user/welcome">
          <img src="/s/style/img/RAA_Header.svg" alt="Room Alert ®" />
          {' '}
        </a>
      </div>
      <div id="main-header-nav">
        <div className="main-header-nav-item ">
          <a className="text-link" href="https://avtech.com/Products/Environment_Monitors/">Products</a>
        </div>
        <div className="main-header-nav-item ">
          <a className="text-link" href="https://avtech.com/support/">Support</a>
        </div>
        {showLoginBtn && (
          <div className="main-header-nav-item ">
            <a className="btn btn-primary btn-sm" href={`${envConfig.raaUrl}/gateway`}>
              Account Login
            </a>
          </div>
        )}
      </div>
    </header>
  </div>
);

PublicHeader.defaultProps = {
  showLoginBtn: false,
};

PublicHeader.propTypes = {
  showLoginBtn: PropTypes.bool,
};

export default PublicHeader;
